import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Content from './Content';
import reportWebVitals from './reportWebVitals';
import { StateProvider } from './stateProvider/stateProvider';
import { initialState } from './reducer/init';
import reducer from './reducer/reducer';



const root = ReactDOM.createRoot(  document.getElementById('root') )
root.render(
  <StateProvider initialState={initialState} reducer={reducer}>
    <Content/>
  </StateProvider>

);

reportWebVitals();
